// Anonymous browse-session tracking (Task 4, 2026-07-04).
// Logs link-only, non-registered visits to /api/analytics/browse for FOUNDER-ONLY
// analytics. Never mints an encounter. Silent, fire-and-forget. Public pages only;
// skips founder mode and gated/admin routes.
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api/analytics/browse`;
const SID_KEY = "pai_browse_sid";
const GATED_PREFIXES = [
  "/admin", "/vault", "/investor-access", "/rounds",
  "/attestation-ledger", "/physician-review", "/feedback",
];

let _started = false;
let _startTs = 0;

function getSessionId() {
  let sid = sessionStorage.getItem(SID_KEY);
  if (!sid) {
    sid = (window.crypto && window.crypto.randomUUID)
      ? window.crypto.randomUUID()
      : `sid-${Date.now()}-${Math.random().toString(36).slice(2)}`;
    sessionStorage.setItem(SID_KEY, sid);
  }
  return sid;
}

function isPublicPath() {
  const p = window.location.pathname || "/";
  return !GATED_PREFIXES.some((pre) => p.startsWith(pre));
}

function send(event, extra = {}) {
  const body = {
    sessionId: getSessionId(),
    event,
    path: window.location.pathname,
    referrer: document.referrer || "",
    ...extra,
  };
  try {
    if (event === "end" && navigator.sendBeacon) {
      navigator.sendBeacon(API, new Blob([JSON.stringify(body)], { type: "application/json" }));
      return;
    }
  } catch (_) { /* fall through to axios */ }
  axios.post(API, body).catch(() => {});
}

export function startBrowseTracking() {
  if (_started) return;
  if (sessionStorage.getItem("pai_founder_mode") === "active") return;
  if (!isPublicPath()) return;
  _started = true;
  _startTs = Date.now();
  send("start");
  const dwell = () => Math.round((Date.now() - _startTs) / 1000);
  setInterval(() => send("heartbeat", { durationSeconds: dwell() }), 30000);
  window.addEventListener("visibilitychange", () => {
    if (document.visibilityState === "hidden") send("end", { durationSeconds: dwell() });
  });
  window.addEventListener("pagehide", () => send("end", { durationSeconds: dwell() }));
}

// Call after a successful explicit registration to flip the browse session → converted.
export function markBrowseRegistered() {
  try {
    axios.post(API, { sessionId: getSessionId(), event: "register" }).catch(() => {});
  } catch (_) { /* no-op */ }
}
